import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "18", height: "18", x: "3", y: "3", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 15h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 15h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 15h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 15h1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PanelBottomInactive";
const PanelBottomInactive = memo(themed(Icon));
export {
  PanelBottomInactive
};
//# sourceMappingURL=panel-bottom-inactive.js.map
